import { IconButton } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

export const AppFooter = ({ currentScreen, totalScreens, onPrev, onNext, formData }) => {
  // Check if all required fields are filled for screen 4
  const isFormValid =
    formData.customerName?.trim() !== '' &&
    formData.executiveName?.trim() !== '' &&
    formData.executiveTitle?.trim() !== '' &&
    formData.primaryCompetitor?.trim() !== '' &&
    formData.industry?.trim() !== '';

  const isNextDisabled = currentScreen === totalScreens || (currentScreen === 4 && !isFormValid);
  const volumeScreens = [2, 3, 6, 7, 8, 9, 10];
  const showVolumeIcon = volumeScreens.includes(currentScreen);

  return (
    <div className="flex pl-4 max-w-xl h-10 justify-between items-center fixed bottom-0 w-screen">
      {/* Show ABOUT and version only on first screen */}
      {currentScreen === 1 ? (
        <div className="text-xs text-gray-500 text-center">
          <div>ABOUT</div>
          <div>V 1.0.1</div>
        </div>
      ) : showVolumeIcon ? (
        <VolumeUpIcon fontSize="large" sx={{ color: '#5F7CF9' }} />
      ) : (
        <div></div>
      )}

      <div className="flex gap-4">
        {/* Previous button - rotated SendRoundedIcon */}
        <IconButton onClick={onPrev} disabled={currentScreen === 1}>
          <SendRoundedIcon
            fontSize="large"
            sx={{
              transform: 'rotate(180deg)',
              color: currentScreen === 1 ? '#d1d5db' : '#5F7CF9',
              '&:hover': {
                color: currentScreen === 1 ? '#d1d5db' : '#4A67D6',
              },
            }}
          />
        </IconButton>

        <IconButton onClick={onNext} disabled={isNextDisabled}>
          <SendRoundedIcon
            fontSize="large"
            sx={{
              color: isNextDisabled ? '#d1d5db' : '#5F7CF9',
              '&:hover': {
                color: isNextDisabled ? '#d1d5db' : '#4A67D6',
              },
            }}
          />
        </IconButton>
      </div>
    </div>
  );
};
